module.exports = __webpack_public_path__ + "static/media/StripesRhom.e1b0b627.png";